import { Debug } from './Debug';
import { faHome } from '@fortawesome/free-solid-svg-icons';

export type DebugRoutes = Record<
    (
        `w/${string}/debug`
        ),
    RouteProps
>;

const routes: DebugRoutes = {
    'w/:wallet_id/debug': {
        path: 'w/:wallet_id/debug',
        title: 'Debug',
        component: Debug,
        auth: true,
        exact: true,
        showTab: false,
        icon: faHome,
    },
};

export default routes;
